import { TableHeadersType } from "./tableHeadersType";

export const ALL_CLIENT_BULK_UPLOAD_LIST_HEADERS: TableHeadersType[] = [
  {
    label: "CLIENT DETAILS",
    value: "client_name",
  },
  {
    label: "UPLOAD TYPE",
    value: "type",
  },
  {
    label: "File Name",
    value: "file",

  },
  {
    label: "Stage",
    value: "stage",

  },
  {
    label: "Added/Modified By",
    value: "created",

  },
  {
    label: "Added/Modified At",
    value: "created_at",

  },
  {
    label: "Action",
    value: "action",

  },
 



];

export const HRMS_BULK_UPLOAD_LIST_HEADERS: TableHeadersType[] = [
 
  {
    label: "File Name",
    value: "file",

  },
  {
    label: "Stage",
    value: "stage",

  },
  {
    label: "Added/Modified By",
    value: "created",

  },
  {
    label: "Added/Modified At",
    value: "created_at",

  },
  {
    label: "Action",
    value: "action",

  },
 



];

export const UPLOAD_TYPE_FILTER: TableHeadersType[] = [
 
  {
    label: "Expense",
    value: "expenses",

  },
  {
    label: "Sales",
    value: "revenues",

  },
  {
    label: "Other",
    value: "others",

  },
  {
    label: "Fixed Asset",
    value: "fixed_asset",

  },
  {
    label: "Customer/Supplier",
    value: "customer_supplier",

  },
  {
    label: "Stock Item",
    value: "stock_item",

  },
 



];